import { gql } from "@grandvisionhq/graphql";
import StoreFragment from "../../../fragments/operations/fragments/store.js";
import StoreInventoryFragment from "../../../fragments/operations/fragments/store-inventory.js";
import StoreOffersFragment from "../../../fragments/operations/fragments/store-offers.js";
import StoreReservabilityFragment from "../../../fragments/operations/fragments/store-reservability.js";
import StoresFilter from "../../../fragments/operations/fragments/stores-filter.js";
const STORES_SEARCH_WITHOUT_INVENTORY = gql`
  query StoresSearchWithoutInventory($input: StoresSearchInput) {
    availableFilters: storesSearch(input: { maxResults: 0 }) {
      filters {
        name
        options {
          name
        }
      }
    }
    filteredResults: storesSearch(input: $input) {
      results {
        ...Store
      }
      filters {
        ...StoresFilter
      }
    }
  }
  ${StoreFragment}
  ${StoresFilter}
`;
const STORES_SEARCH_WITH_INVENTORY = gql`
  query StoresSearchWithInventory($input: StoresSearchInput, $sku: ID!) {
    availableFilters: storesSearch(input: { maxResults: 0 }) {
      filters {
        name
        options {
          name
        }
      }
    }
    filteredResults: storesSearch(input: $input) {
      results {
        ...Store
        ...StoreInventory
        ...StoreReservability
        ...StoreOffers
      }
      filters {
        ...StoresFilter
      }
    }
  }
  ${StoreFragment}
  ${StoreInventoryFragment}
  ${StoreReservabilityFragment}
  ${StoreOffersFragment}
  ${StoresFilter}
`;
export {
  STORES_SEARCH_WITHOUT_INVENTORY,
  STORES_SEARCH_WITH_INVENTORY
};
//# sourceMappingURL=stores-search.js.map
